module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/logo-coj-zh-hant-8588cfcc54f6a9e049029b8d5c4ea85b.png";